"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeStyles = exports.applyStyles = void 0;

var _draftJs = require("draft-js");

var applyStyles = function applyStyles(contentState, selection, styles) {
  return styles.reduce(function (updatedContentState, style) {
    return _draftJs.Modifier.applyInlineStyle(updatedContentState, selection, style);
  }, contentState);
};

exports.applyStyles = applyStyles;

var removeStyles = function removeStyles(contentState, selection, allInlineStyles) {
  return allInlineStyles.reduce(function (updatedContentState, style) {
    return _draftJs.Modifier.removeInlineStyle(updatedContentState, selection, style);
  }, contentState);
};

exports.removeStyles = removeStyles;